import * as Yup from "yup";

export const referringProviderSchema = () =>
  Yup.object({
    name: Yup.string()
      .trim()
      .max(100, "Provider name cannot be more than 100 characters.")
      .required("Provider Name is required"),
    npi: Yup.string()
      .matches(/^[1-9][0-9]{9}$/, "Invalid NPI")
      .required("NPI is required"),
    account: Yup.string().required("Account is required"),
    street: Yup.string()
      .trim()
      .max(100, "Street address cannot be more than 100 characters."),
    state: Yup.string(),
    zip: Yup.string().trim().max(15, "Zip cannot be more than 15 characters."),
    default: Yup.boolean().required(),
  });
